module.exports = __webpack_public_path__ + "img/aniImg4.4a333518.png";